import type { Money } from "./types";

export function dollars(amount: number): Money {
  return { amountCents: Math.round(amount * 100), currency: "USD" };
}

export function parseMoney(value: string): Money | undefined {
  const amount = Number.parseFloat(value.replace(/[^0-9.-]/g, ""));
  if (!Number.isFinite(amount)) return undefined;
  return dollars(amount);
}

export function formatMoney(value?: Money): string {
  if (!value) return "Not recorded";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: value.currency
  }).format(value.amountCents / 100);
}

export function sameMoney(a?: Money, b?: Money): boolean {
  if (!a || !b) return false;
  return a.currency === b.currency && a.amountCents === b.amountCents;
}

export function moneyDifference(a?: Money, b?: Money): Money | undefined {
  if (!a || !b || a.currency !== b.currency) return undefined;
  return { amountCents: a.amountCents - b.amountCents, currency: a.currency };
}
